import styled, { css } from 'styled-components';
import { FormField } from 'ui/formField';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { DetailsSectionTitle } from '../styles';

export const MainSection = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  gap: ${spacing.plusHalf};
  padding: ${spacing.double} 0;

  @media screen and (max-width: ${pxToRem(893)}) {
    flex-direction: column;
    align-items: center;
  }

  @media screen and (min-width: ${pxToRem(1681)}) {
    width: ${pxToRem(1842)};
    margin: auto;
  }
`;

export const SettingsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
  min-width: 0;
  max-width: ${pxToRem(720)}; /** Width of left-side content in Template and Campaign edit pages */
`;

export const PreviewWrapper = styled.div`
  height: max-content;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 50%;
`;

export const ContentBlock = styled.div`
  border: ${spacing.single} solid ${colors.grey15};
  border-radius: ${spacing.half};
  padding: ${spacing.plusHalf};

  h4 {
    margin-bottom: ${spacing.double};
  }
`;

export const StyledFormField = styled(FormField)`
  align-items: flex-start;

  > div {
    display: flex;
    gap: ${pxToRem(10)};
    align-items: center;

    [data-test='toggle-form-field-help-text'] {
      color: ${colors.textSecondary};
    }
  }

  [data-test='form-field-header'] {
    margin-bottom: 0;
  }
`;

export const LabelWithHelpIcon = styled.div`
  display: flex;
  gap: ${spacing.quarter};
  align-items: center;
`;

export const Section = styled.div`
  margin-top: ${spacing.double};
`;

export const StyledSectionTitle = styled(DetailsSectionTitle)`
  margin-bottom: ${spacing.plusHalf};
`;

export const LoadingContainer = styled.div`
  overflow: visible;
  height: 80vh;
  width: 100%;
`;

export const HideableFormField = styled(FormField)<{ $hidden?: boolean }>`
  ${({ $hidden }) =>
    $hidden &&
    css`
      display: none;
    `}
`;
